<template>
    <div class="loading-body">
        <font-awesome-icon icon="circle-notch" class="rotating"></font-awesome-icon>
    </div>
</template>

<script>
    export default {
        name: 'loading'
        
    }
</script>

<style scoped>
.loading-body{
    position: absolute;
    left: 0;
    right: 0;
    top: 45px;
    text-align: center;
    font-size: 8rem;
    color: #5FA963;
}
@-webkit-keyframes rotating /* Safari and Chrome */ {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.rotating {
    -webkit-animation: rotating 0.8s linear infinite;
    -moz-animation: rotating 0.8s linear infinite;
    -ms-animation: rotating 0.8s linear infinite;
    -o-animation: rotating 0.8s linear infinite;
    animation: rotating 0.8s linear infinite;
}
</style>
